import React, { Component } from 'react';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import { Layout, notification } from 'antd/lib';

import * as actionsPersonas from '../../../actions/personas';
import * as actionsMain from '../../../actions/main';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

class SumarPersona extends Component {
  state = {
    persona: {},
  };

  guardarPersona = persona => {
    //Aca debo controlar que esa persona no exista ya en las props.
    // let per = _.find(this.props.personas, { _id: persona._id, });
    let per = false;  //Para la autorizacion de viaje de menores, se permite cargar una misma persona como padre y autorizante

    if (per) {
      //Esto significa que ya existia la persona y no debo volver a cargarla.
      notification.error({
        message: 'Persona Existente',
        description:
          'La persona que intento ingresar, ya existia en la autorizacion',
      });
      this.props.actionsMain.setCargaPersonas(
        !this.props.main.cargaPersonasToggle
      );
    } else {
      this.setState(
        {
          ...this.state,
          persona: {
            ...this.state.persona,
            ...persona,
          },
        },
        () => {
          // this.props.history.push('agregarPersona/')

          //Actualizar REDUX
          this.props.actionsPersonas.agregarPersona(persona);
          this.props.actionsMain.setCargaPersonas(
            !this.props.main.cargaPersonasToggle
          );

          // //REDIRIGIR
          // this.props.history.goBack();
        }
      );
    }
  };

  onCancel = () => {
    this.props.actionsMain.setCargaPersonas(
      !this.props.main.cargaPersonasToggle
    );
  };

  render() {
    return (
      <div>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <div style={estiloContent}>
            <BuscarYCrearPersona
              obtenerPersona={this.guardarPersona}
              onCancel={this.onCancel}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPersonas: bindActionCreators(actionsPersonas, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SumarPersona);
